/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CodexFieldWallet.vue?vue&type=template&id=9b1950de&scoped=true"
import script from "./CodexFieldWallet.vue?vue&type=script&lang=js"
export * from "./CodexFieldWallet.vue?vue&type=script&lang=js"
import style1 from "./CodexFieldWallet.vue?vue&type=style&index=1&id=9b1950de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1950de",
  null
  
)

export default component.exports